
import { Injectable, DOCUMENT, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {
  private _document = inject<HTMLDocument>(DOCUMENT);


  setFavicon(path: string) {
    if (!path) {
      return;
    }
    const faviconElement = this._document.getElementById('appFavicon');
    if (faviconElement) {
      faviconElement.setAttribute('href', path);
    }
  }
}
